import Base from "@/controllers/base";
export default class Geo extends Base {
  constructor(elem) {
    super(elem);
  }

  async showMap(event) {
    try {
      const select = event.target;
      const response = await fetch(`/locations/${select.value}/map.json`);
      const result = await response.json();
      const img = this.elem.querySelector(".image-map img");
      const address = this.elem.querySelector(".image-map .address");
      img.setAttribute("src", result.base64);
      address.innerHTML = result.address;
    } catch (ex) {
      console.log(ex);
    }
  }
}
